const newInspection = {};
export default newInspection;
